import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewTwo',
  templateUrl: './viewTwo.component.html',
  styleUrls: ['./viewTwo.component.css']
})
export class ViewTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
